// Editorial selection for the app.hubbing.ch trial: official reference links,
// original short summaries and publisher-hosted photographs, without an automatic feed.
export const BUSINESS_NEWS_SELECTED_AT = "2026-10-29"
export const BUSINESS_NEWS_SOURCES = {
  "la-vie-economique": {
    "label": "La Vie économique",
    "publisher": "SECO",
    "moreUrl": "https://dievolkswirtschaft.ch/fr/",
    "hostname": "dievolkswirtschaft.ch"
  },
  "portail-pme": {
    "label": "Portail PME",
    "publisher": "SECO",
    "moreUrl": "https://www.kmu.admin.ch/fr/news-fr",
    "hostname": "www.kmu.admin.ch"
  }
}
export const BUSINESS_NEWS_ARTICLES = [
  {
    "id": "lve-20261029-pme-grandes-entreprises",
    "source": "la-vie-economique",
    "title": "PME et grands groupes : des échanges essentiels en Suisse",
    "publishedAt": "2026-10-29",
    "url": "https://dievolkswirtschaft.ch/fr/2026/10/les-pme-ont-besoin-des-grandes-entreprises-et-inversement/",
    "summary": "Une enquête menée dans le canton de Zurich montre comment PME et grandes entreprises travaillent ensemble, notamment à travers leurs fournisseurs et leurs clients.",
    "image": {
      "src": "https://dievolkswirtschaft.ch/content/uploads/2026/10/Zobrist_727884664_web-1024x552.jpg",
      "alt": "Photo publiée par La Vie économique pour l’article sur les liens entre PME et grandes entreprises.",
      "credit": "© Keystone · La Vie économique"
    },
    "translations": {
      "de": {
        "title": "KMU und Grossunternehmen: ein wichtiges Zusammenspiel in der Schweiz",
        "summary": "Eine Erhebung im Kanton Zürich zeigt, wie KMU und Grossunternehmen zusammenarbeiten, insbesondere über ihre Lieferanten und Kunden.",
        "imageAlt": "Von La Vie économique veröffentlichtes Foto zum Artikel über die Beziehungen zwischen KMU und Grossunternehmen."
      },
      "it": {
        "title": "PMI e grandi imprese: scambi essenziali in Svizzera",
        "summary": "Un’indagine condotta nel Cantone di Zurigo mostra come PMI e grandi imprese collaborano, in particolare attraverso i rapporti con fornitori e clienti.",
        "imageAlt": "Foto pubblicata da La Vie économique per l’articolo sui legami tra PMI e grandi imprese."
      },
      "en": {
        "title": "SMEs and large companies: essential business ties in Switzerland",
        "summary": "A survey in the canton of Zurich shows how SMEs and large companies work together, particularly through their suppliers and customers.",
        "imageAlt": "Photo published by La Vie économique for the article on ties between SMEs and large companies."
      }
    }
  },
  {
    "id": "lve-20261027-surveillance-banques",
    "source": "la-vie-economique",
    "title": "La FINMA pourrait intervenir plus tôt face aux risques",
    "publishedAt": "2026-10-27",
    "url": "https://dievolkswirtschaft.ch/fr/2026/10/surveillance-des-banques-la-finma-doit-pouvoir-intervenir-en-amont-des-crises/",
    "summary": "Le Conseil fédéral souhaite renforcer les moyens d’intervention précoce de la FINMA afin d’agir lorsque des risques bancaires se dessinent.",
    "image": {
      "src": "https://dievolkswirtschaft.ch/content/uploads/2026/10/Nussbaumer_688320522_web-1024x552.jpg",
      "alt": "Photo publiée par La Vie économique pour l’article sur la surveillance bancaire.",
      "credit": "© Keystone · La Vie économique"
    },
    "translations": {
      "de": {
        "title": "Die FINMA könnte bei Risiken früher eingreifen",
        "summary": "Der Bundesrat will die Möglichkeiten der FINMA zur Frühintervention stärken, damit sie handeln kann, sobald sich Risiken im Bankensektor abzeichnen.",
        "imageAlt": "Von La Vie économique veröffentlichtes Foto zum Artikel über die Bankenaufsicht."
      },
      "it": {
        "title": "La FINMA potrebbe intervenire prima di fronte ai rischi",
        "summary": "Il Consiglio federale intende rafforzare gli strumenti di intervento precoce della FINMA, per permetterle di agire quando emergono rischi nel settore bancario.",
        "imageAlt": "Foto pubblicata da La Vie économique per l’articolo sulla vigilanza bancaria."
      },
      "en": {
        "title": "FINMA could intervene earlier when risks emerge",
        "summary": "The Federal Council wants to strengthen FINMA’s early intervention powers so it can act when risks emerge in the banking sector.",
        "imageAlt": "Photo published by La Vie économique for the article on banking supervision."
      }
    }
  },
  {
    "id": "pme-20261007-financement",
    "source": "portail-pme",
    "title": "Financement des PME : crédit solide, conditions encore contraignantes",
    "publishedAt": "2026-10-07",
    "url": "https://www.kmu.admin.ch/fr/le-financement-des-pme-reste-robuste-mais-se-resserre",
    "summary": "Le crédit aux PME progresse, mais l’accès au financement reste plus contraignant pour certaines entreprises, notamment en matière de garanties.",
    "image": {
      "src": "https://prod-kmuadminch-hcms-sdweb.imgix.net/dam/fr/sd-web/gTybobmE1KO1/261007_le_financement_des_pme_reste_robuste_mais_se_resserre.png?auto=format&w=1024",
      "alt": "Photo publiée par le Portail PME pour l’article sur le financement des entreprises.",
      "credit": "© Adobe Stock · Portail PME"
    },
    "translations": {
      "de": {
        "title": "KMU-Finanzierung: robuste Kreditvergabe, weiterhin anspruchsvolle Bedingungen",
        "summary": "Die Kreditvergabe an KMU wächst. Für manche Unternehmen bleibt der Zugang zur Finanzierung jedoch schwieriger, insbesondere wegen der Anforderungen an Sicherheiten.",
        "imageAlt": "Vom Portail PME veröffentlichtes Foto zum Artikel über die Unternehmensfinanzierung."
      },
      "it": {
        "title": "Finanziamento delle PMI: credito solido, condizioni ancora restrittive",
        "summary": "Il credito alle PMI cresce, ma per alcune imprese l’accesso ai finanziamenti resta più restrittivo, soprattutto per quanto riguarda le garanzie richieste.",
        "imageAlt": "Foto pubblicata dal Portail PME per l’articolo sul finanziamento delle imprese."
      },
      "en": {
        "title": "SME financing: resilient lending, but conditions remain demanding",
        "summary": "Lending to SMEs is growing, but access to financing remains more restrictive for some businesses, particularly when it comes to collateral requirements.",
        "imageAlt": "Photo published by Portail PME for the article on business financing."
      }
    }
  }
]

// Only Hubbing's short editorial copy is translated. Official article/photo
// URLs, publication dates, publisher names and photo credits remain untouched.
export function businessNewsArticleCopy(article,lang = 'fr') {
  const language = ['fr','de','it','en'].includes(lang) ? lang : 'fr'
  const translated = article?.translations?.[language]
  return {
    title: translated?.title || article?.title || '',
    summary: translated?.summary || article?.summary || '',
    imageAlt: translated?.imageAlt || article?.image?.alt || '',
  }
}
